import * as React from "react";
import {Box, Grid} from "@mui/material";
import OverallBalance from "@/pages/Analyze/Customer/OverallBalance";
import SalesChance from "@/pages/Analyze/Customer/SalesChance";
import ProjectCard from "@/pages/Analyze/Customer/ProjectCard";
import PatentCard from "@/pages/Analyze/Customer/PatentCard";
import TrademarkCard from "@/pages/Analyze/Customer/TrademarkCard";
import CopyrightCard from "@/pages/Analyze/Customer/CopyrightCard";
import {useQueryAddCustomerTrend, useQueryAddProductTrend, useQueryCustomerYearCompare} from "@/service/analyze";
import YearCustomerTrend from "@/pages/Analyze/Customer/YearCustomerTrend";
import YearContractTrend from "@/pages/Analyze/Customer/YearContractTrend";
import SellerProductAmount from "@/pages/Analyze/Customer/SellerProductAmount";
import Last7dCustomer from "@/pages/Analyze/Customer/Last7dCustomer";

export default function AnalyzePage() {
    const {data: addCustomerTrendData, isPending: addCustomerPending} = useQueryAddCustomerTrend()
    const addCustomerTrend = addCustomerTrendData?.data
    const {data: addProductTrendData, isPending: addProductTrendPending} = useQueryAddProductTrend()
    const addProductTrend = addProductTrendData?.data
    const {data: customerYearCompareData, isPending: customerYearComparePending} = useQueryCustomerYearCompare()
    const customerYearCompare = customerYearCompareData?.data

    return (
        <Box sx={{width: "100%", maxWidth: {sm: "100%", md: "1700px"}}}>
            <Grid
                container
                spacing={2}
                columns={12}
            >
                <Grid size={{xs: 12, md: 6.8}}>
                    <OverallBalance loading={addCustomerPending} recentYearCustomers={addCustomerTrend?.recentYearCustomers}/>
                </Grid>
                <Grid size={{xs: 12, md: 5.2}}>
                    <SalesChance loading={addCustomerPending} recent7MonthChances={addCustomerTrend?.recent7MonthChances}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 3}}>
                    <ProjectCard loading={addProductTrendPending} projects={addProductTrend?.projects}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 3}}>
                    <PatentCard loading={addProductTrendPending} patents={addProductTrend?.patents}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 3}}>
                    <TrademarkCard loading={addProductTrendPending} trademarks={addProductTrend?.trademarks}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 3}}>
                    <CopyrightCard loading={addProductTrendPending} copyrights={addProductTrend?.copyrights}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <SellerProductAmount loading={addProductTrendPending} creators={addProductTrend?.creators}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <Last7dCustomer loading={addCustomerPending} dealsCreator={addCustomerTrend?.dealsCreator || []}
                                    leadsTrend={addCustomerTrend?.leadsTrend || []}
                                    dealsTrend={addCustomerTrend?.dealsTrend || []}
                                    leadsCreator={addCustomerTrend?.leadsCreator || []}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <YearCustomerTrend loading={customerYearComparePending} customerDist={customerYearCompare?.customerDist} customers={customerYearCompare?.customers}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <YearContractTrend loading={customerYearComparePending} contracts={customerYearCompare?.contracts}
                                       product={{
                                           "项目": customerYearCompare?.projectDist || [], "专利": customerYearCompare?.patentDist || [],
                                           "版权": customerYearCompare?.copyrightDist || [], "商标": customerYearCompare?.trademarkDist || []
                                       }}/>
                </Grid>

            </Grid>
        </Box>
    );
}
